import { TradingGatewayApiClient } from 'common/api/autogenerated/trading-gateway';

const tradingGatewayApiClient = new TradingGatewayApiClient({
  BASE: '/trading-gateway',
  WITH_CREDENTIALS: true,
});

export const getTrades = (count = 999) =>
  tradingGatewayApiClient.spotTrading.getV1SpotCustomerTrades(undefined, undefined, count);
export const getOrders = () => tradingGatewayApiClient.spotTrading.getV1SpotCustomerOrders(undefined, undefined, 999);
export const deleteOrder = (orderId: number) =>
  tradingGatewayApiClient.spotTrading.postV1SpotCustomerOrdersCancel(orderId);
